import React from 'react';

const LoadingPage = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-white">
      <div
        className="spinner-border text-primary mb-4"
        role="status"
        style={{
          width: '4rem',
          height: '4rem',
          borderWidth: '0.4em'
        }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <h3 className="fw-semibold text-dark mb-2">Just a moment...</h3>
      <p className="text-secondary" style={{ fontSize: '1rem' }}>
        We're getting everything ready for you.
      </p>
    </div>
  );
};

export default LoadingPage;
